<template>
  <div class="w-full">
    <div class="float-tile white-tile top-tile" />
    <div class="float-tile transparent-tile left-24 -top-14 bg-gradient-to-b from-blue-start to-blue-end top-tile" />
    <div class="flex justify-center items-center min-h-screen z-10 relative">
      <div class="w-full md:w-8/12 xl:w-4/12 max-w-lg">
        <div class="rounded p-5">
          <logo class="h-20 mb-8 mx-auto" />
          <div class="card-body bg-bs-yellow py-3 rounded-xl shadow-xl">
            <h3 class="text-xl font-medium text-bs-dark-bg">An email has been sent to your account. Please verify your email.</h3>
          </div>
          <button class="text-bs-gray-dark dark:text-bs-gray-light mt-4" @click="resendEmail">{{emailResent ? 'Email Resent' : 'Resend email?'}}</button> 
          <br/>
          <button class="text-bs-gray-dark dark:text-bs-gray-light mt-4" @click="onLogout">Logout</button> 
        </div>
      </div>
    </div>
    <div class="float-tile white-tile fixed-bottom-tile-position bottom-tile" />
    <div class="float-tile transparent-tile right-24 -bottom-20 bg-gradient-to-b from-green-start to-green-end bottom-tile" />
  </div>
</template>


<script>
import firebase from '@/firebase'
import Logo from '../../atoms/Logo.vue';

export default {
  components: { Logo },
  
  data () {
    return {
      emailResent: false
    };
  },
  created() {
    this.checkUser()
  },
  methods: {
    checkUser: async function(){
      let user = await firebase.getCurrentUser();
      if (!user) {
        this.$router.replace({ name: 'Login'})
      }
    },
    resendEmail: async function () {
      if (this.emailResent) {
        return false;
      }
			firebase.auth().currentUser.sendEmailVerification().then(() => {
        this.emailResent = true
      })
		},
    onLogout: function() {
			firebase.auth().signOut();
			this.$router.replace({ name: "Login" });
		},
  }
};
</script>